export default __webpack_public_path__ + "static/media/IF_MyLeadershipStrengths_StrengthDesc_01.a95767bb.jpg";